// Product names are free-text, admin-entered (see pws-con/ProductManagement.jsx) -
// there's no fixed enum to map 1:1 like the category filter has. This does a
// best-effort word/phrase substitution for the known Norwegian terms actually used
// in product names (Lek, Klippekort, minutter, runde, etc.) instead of leaving the
// whole name untranslated when English is selected.
// ponytail: word-substitution heuristic, not a real translation - upgrade to a
// per-product name_en column if the catalog ever needs exact wording.
const WORD_SUBSTITUTIONS = [
  [/\bKlippekort\b/gi, 'Punch card'],
  [/\bhele dagen\b/gi, 'all day'],
  [/\btimer\b/gi, 'hours'],
  [/\btime\b/gi, 'hour'],
  [/\bminutter\b/gi, 'minutes'],
  [/\bminutt\b/gi, 'minute'],
  [/\brunder\b/gi, 'rounds'],
  [/\brunde\b/gi, 'round'],
  [/\bvoksen\b/gi, 'adult'],
  [/\bvoksne\b/gi, 'adults'],
  [/\bbarn\b/gi, 'child'],
  [/\bfamilie\b/gi, 'family'],
  [/\bgruppe\b/gi, 'group'],
  [/\bklipp\b/gi, 'punches'],
  [/\bLek\b/gi, 'Playground'],
];

export function translateProductName(name, language) {
  if (language !== 'en' || !name) return name;
  return WORD_SUBSTITUTIONS.reduce((result, [pattern, replacement]) => result.replace(pattern, replacement), name);
}
